import styled from "styled-components";
import { colors } from "../theme";
import { bgColorProp } from "./helpers";

export const Space = styled.div`
  display: flex;
  ${(pr) => !pr.row && `flex-direction: column;`}
  gap: ${(pr) => pr.gap || "1rem"};
`;

export const Box = styled.div`
  width: ${(pr) => pr.width};
  min-width: ${(pr) => pr.minWidth};
  height: ${(pr) => pr.height};
  border: ${(pr) => pr.border};
  border-radius: ${(pr) => pr.borderRadius};
  box-shadow: ${(pr) => pr.boxShadow};
  ${bgColorProp};
`;

export const GradientBox = styled(Box)`
  background-image: ${(pr) => {
    return {
      5: "linear-gradient(to bottom, #a68746, #c5a03c, #e3bb2c)",
      4: "linear-gradient(to bottom, #7e4da6, #9b4cc6, #bd44e4)",
      3: "linear-gradient(to bottom, #5d8fa8, #72aae3, #8bb6ff)",
      2: "linear-gradient(to bottom, #5ca862, #61c370, #63dd7e)",
      1: "linear-gradient(to bottom, #6c6969, #8c8989, #9c9a9a)"
    }[pr.bgImg];
  }};
`;

export const AbsoluteBox = styled.div`
  position: absolute;
  top: ${(pr) => pr.top};
  bottom: ${(pr) => pr.bottom};
  left: ${(pr) => pr.left};
  right: ${(pr) => pr.right};
  z-index: ${(pr) => pr.zIndex};
  transform: ${(pr) => pr.transform};
`;

export const HiddenSpace = styled.div`
  width: 0;
  transition: width 200ms ease-in-out;
  &.show {
    width: ${(pr) => pr.openWidth};
  }
`;

export const MobileNavBtn = styled.button`
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  background-color: ${colors.cardBg3};
  color: white;
  font-size: 1.5rem;
  &.showing {
    background-color: ${colors.cardBg1};
    color: ${colors.green};
  }
`;
